<template>
  <div v-if="$store.state.app.language === 'en-us'"  class="ai_command_box" style="margin-top:24px;">
    <el-button type="primary" v-if="type == 'wt'" @click="open()">{{$t('components_ai_command_index_1954')}}</el-button>
    <el-button type="primary" v-if="type == 'tkd'" @click="tkdDialogShow = true">{{$t('components_ai_command_index_1955')}}</el-button>

    <Write ref="writeDialog" v-if="type == 'wt'"  @pushCont="pushCont" @closeDialogForm="closeDialogForm" :command_type="command_type"></Write>
    <Tkd  v-if="type == 'tkd'" :seoTitleType="seoTitleType" :isShow.sync="tkdDialogShow" @closeDialogForm="closeDialogForm" @pushTkd="pushTkd" :command_type="command_type"></Tkd>    
  </div>
</template>
<script>
import i18n from '../../language/index'


import Write from './write.vue';
import Tkd from './tkd.vue';

export default {
  name: "ai_command",
  data () {
    return {
      wtDialogShow: false,
      tkdDialogShow: false,
    };
  },
  props: {
    command_type: {
      type: String,
      required: true,
      default: "",
    },
    type: {
      type: String,
      required: true,
      default: "",
    },
    seoTitleType: {
      type: String,
      default: ''
    }
  },
  watch: {
    
  },
  methods: {
      open(){
        this.$refs['writeDialog'].showDialog()
        this.wtDialogShow = true
      },
      closeDialogForm() {
        this.wtDialogShow = false
        this.tkdDialogShow = false
      },
      pushCont(cont){
        this.$emit('pushCont', cont);
      },
      pushTkd(cont) {
        this.$emit('pushTkd', cont);
      },
  },
  computed: {

  },
  components: {
    Write,
    Tkd,
  },
  created () {

  },
  mounted () {
      console.log('zxcxzczxc');
  }
}
</script>

<style scoped lang="scss">

/deep/ .ai_command_box {
  display: flex;
  height: 140px;
  margin-top: 24px;
}
</style>

<style lang="scss">
@import "~@/css/style_zzz.scss";
</style>



// WEBPACK FOOTER //
// src/components/ai_command/index.vue